import { Input as I } from "@mantine/core";
import { palette } from "../../../theme";

export const TextInput = (props) => {
  return (
    <I
      required
      autoComplete="off"
      id={props.id}
      placeholder="E-mail"
      radius={12}
      mt={16}
      size="lg"
      autocomplete="off"
      {...props.form.getInputProps(props.formFieldName)}
      styles={{
        input: {
          fontFamily: "Roboto",
          background: palette.grayUI[1],
          borderColor: palette.grayUI[1],
          borderWidth: "1px",
          borderStyle: "solid",
          color: palette.grayUI[4],
          transition: "all 200ms ease",
          boxShadow: `6px 6px 12px ${palette.grayUI[2]},
             -6px -6px 12px ${palette.grayUI[0]}`,
          "&:hover": {
            background: palette.grayUI[1],
            boxShadow: `6px 6px 12px ${palette.grayUI[2]},
             -6px -6px 12px ${palette.grayUI[0]}, inset 0 0 4px 0 rgba(0,0,0,0.25), inset 0 0 5px 0 white`,
          },
        },
      }}
      {...props}
    />
  );
};
